import { Center } from '@chakra-ui/react';
import React from 'react';

export const DataMissing: React.FC = () => {
  return <Center h="100%">No data available</Center>;
};
